import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-integrations-azure-ad-sso',
  templateUrl: './integrations-azure-ad-sso.component.html',
  styleUrls: ['./integrations-azure-ad-sso.component.scss']
})
export class IntegrationsAzureAdSSOComponent implements OnInit {

  // configuration
  singleSignOnURL : string
  x509certificate : string
  domain: string
  
  // view
  view : "notConfigured" | "editConfiguration" | "configured" | "notAvailable" = "notConfigured"
  alertNotAvailable = false;

  constructor() { }

  ngOnInit(): void {
  }


  save() {
    this.view = "notAvailable"
    this.alertNotAvailable = true;
  }

  closeAlert() {
    this.alertNotAvailable = false;
  }

  setupSAML() {
    this.view = "editConfiguration";
  }

  return() {
    this.view = "notConfigured"
  }

}
